// extracted by mini-css-extract-plugin
export var indeterminate = "_3w-5";
export var md = "_3w-4";
export var semantic = "_3w-6";
export var sm = "_3w-3";
export var text = "_3w-7";
export var toggleInput = "_3w-0";
export var toggleSwitch = "_3w-1";
export var xs = "_3w-2";